import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { Point } from "pixi.js";
import { GameFontStyle } from "../style/GameFontStyle";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
export class BigWinProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.mouseBlocker = new MouseBlockerProperties(0x00367e, 0.56, false);
        this.lightBurstProperties = new SpineProperties("GodRays", "Game", new Point(973, 650), new Point(0.4, 0.4), new Point(0.5, 0.5));
        this.animation = new SpineProperties("WinBanners", "Game", new Point(973, 370));
        this.value = new TextFieldProperties(GameFontStyle.BIG_WIN_VALUE, new Point(973, 650), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(800, 250));
        // TODO TEMP lang keys used - Add real lang keys
        this.titleWin = new TextFieldProperties(GameFontStyle.BIG_WIN_TITLE, new Point(0, 0), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(960, 800));
        this.titleBigWin = new TextFieldProperties(GameFontStyle.BIG_WIN_TITLE, new Point(0, 0), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(960, 800));
        this.titleSuperBigWin = new TextFieldProperties(GameFontStyle.BIG_WIN_TITLE, new Point(0, 0), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(960, 800));
        this.titleMegaWin = new TextFieldProperties(GameFontStyle.BIG_WIN_TITLE, new Point(0, 0), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(960, 800));
    }
}
//# sourceMappingURL=BigWinProperties.js.map